import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";


class OkulListeAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "OkulListe";
    super(baseUrl);
  }


  getOkulListe( okulKodu?: number){
    return this.get("", { params: { okulKodu: okulKodu } })

  }

}


export default new OkulListeAPI();
class OkulListeListeRequest {
  public okulKodu?: number;

 
  constructor(okulKodu?: number) {
   
      this.okulKodu = okulKodu;

      
  }
}
export { OkulListeListeRequest };